module.exports = __webpack_public_path__ + "img/icons BFr_19.0521d5fd.png";